import { StyleSheet, Platform } from 'react-native'


export const styles = StyleSheet.create({
    displayNone: {
        display: 'none'
    },
})
